import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import cognito from '@/cognito'
import Auth from '@/components/Auth'
import Login from '@/components/Login'
import Logout from '@/components/Logout'
import Signup from '@/components/Signup'
import Confirm from '@/components/Confirm'
import ForgotPassword from '@/components/ForgotPassword'
import ConfirmPassword from '@/components/ConfirmPassword'
import ChangePassword from '@/components/ChangePassword'
import Profile from '@/components/Profile'

Vue.use(Router)

const requireAuth = (to, from, next) => {
  cognito.isAuthenticated()
    .then(session => {
      next()
    })
    .catch(session => {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    })
}

const logout = (to, from, next) => {
  cognito.logout()
  next('/login')
}

const withdraw = (to, from, next) => {
  cognito.deleteUser()
  next('/login')
}

export default new Router({
  mode: 'history',
  routes: [
    { path: '/',
      redirect: 'home'
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      beforeEnter: requireAuth
    },
    {
      path: '/password',
      name: 'ChangePassword',
      component: ChangePassword,
      beforeEnter: requireAuth
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      beforeEnter: requireAuth
    },
    {
      path: '/auth',
      name: 'Auth',
      component: Auth
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/confirm',
      name: 'Confirm',
      component: Confirm
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/confirm-password',
      name: 'ConfirmPassword',
      component: ConfirmPassword
    },
    { path: '/logout',
      beforeEnter: logout
    },
    { path: '/withdraw',
      beforeEnter:  withdraw
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js